/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {Toast} from './index';

export function template(this: Toast) {
  const {delayRemove} = this.state;
  const hide = this.attr(`hide`);
  const timeout = this.attr(`timeout`);
  const type = this.attr(`type`);
  const cta = this.attr(`cta`);
  const ctaHref = this.attr(`cta-href`);
  const ctaTarget = this.attr(`cta-target`);
  const undoable = this.attr(`undoable`);
  const hideCancelButton = this.attr(`hide-cancel-button`);
  // href attr only exist when ctaHref exists
  const ctaElement = cta ? (
    <a
      sel='.mp-toast-action.mp-toast-cta'
      attrs={ctaHref ? {href: ctaHref, target: ctaTarget} : {}}
      on={{click: this.helpers.ctaClick}}
    >
      {cta}
    </a>
  ) : null;

  return (
    <div sel='.mp-toast-stage'>
      {!hide && (
        <div
          sel='.mp-toast-container'
          class={{
            // casting to any, since snabbdom-delayed-module uses a non standard way to hook into snabbdom
            // TODO: modify VNode class definition in Panel to include snabbdom-delayed-module classes
            delayed: {'mp-toast-in': true} as any,
            remove: {'mp-toast-out': true, delayRemove} as any,
          }}
        >
          <div sel='.mp-toast-widget'>
            <div
              sel='.icon-container'
              class={{
                [type]: true,
                timeout,
              }}
            >
              <SvgIconEl attrs={{icon: this.helpers.getIcon()}} />
              {timeout ? (
                <div
                  sel='.icon-container-animated-fadeout'
                  class={{[type]: true}}
                  style={{'animation-duration': timeout + `ms`}}
                />
              ) : null}
            </div>
            <div sel='.mp-toast-body'>
              <div sel='.mp-toast-message'>
                <slot />
              </div>
              <div sel='.mp-toast-actions'>
                {ctaElement}
                {undoable ? (
                  <div sel='.mp-toast-action.mp-toast-undo' on={{click: this.helpers.undoClick}}>
                    {this.attr(`undo-label`)}
                  </div>
                ) : null}
              </div>
              {!hideCancelButton ? (
                <div sel='.mp-toast-close' on={{click: this.helpers.closeClick}}>
                  <SvgIconEl attrs={{icon: `x`}} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
